<template>
  <el-dialog
    title="修改附加信息"
    :visible.sync="dialogFormEditCompanyInfo"
    @close="close"
    :modal-append-to-body="false"
    :close-on-click-modal="false"
  >
    <el-form :model="form" :rules="rules" label-width="100" ref="form">
      <el-form-item label="所属京东云销售：" prop="erp">
        <el-input v-model="form.erp"></el-input>
      </el-form-item>

      <span
        >该下级渠道商所属的京东云销售，默认为您的销售，您可以按业务进行修改</span
      >
    </el-form>

    <div slot="footer" class="dialog-footer">
      <el-button @click="close">取 消</el-button>

      <el-button type="primary" @click="submit">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { modifySecondInfo } from '@/api/distributor-api'
import { SERVICE_PROVIDER_CREATE_RULE } from '@/views/service/rules'
export default {
  props: {
    infoData: {
      require: true,
    },
  },
  components: {},
  mixins: [],
  data() {
    return {
      dialogFormEditCompanyInfo: false,
      distributorId: this.$route.params.id,
      form: {
        erp: '',
      },
      defaultForm: {},
      rules: SERVICE_PROVIDER_CREATE_RULE.call(this),
    }
  },
  watch: {
    infoData(val) {
      this.form = Object.assign({}, val)
      this.defaultForm = Object.assign(this.defaultForm, val)
    },
  },
  methods: {
    showDialog() {
      this.dialogFormEditCompanyInfo = true
      this.form = Object.assign({}, this.infoData)
      this.defaultForm = Object.assign(this.defaultForm, this.infoData)
    },
    close() {
      this.$refs.form.resetFields()
      this.dialogFormEditCompanyInfo = false
    },
    submit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.updateFirstClientInfo()
        } else {
          return false
        }
      })
    },
    async updateFirstClientInfo() {
      let { erp } = this.form
      let { distributorId } = this
      let submitForm = Object.assign({}, this.form)
      submitForm.distributorId = distributorId
      if (erp !== this.defaultForm.erp) {
        await modifySecondInfo(submitForm)
        this.outMsg('success', '提交成功')
        this.close()
        this.$emit('submitSuccess')
      } else {
        this.close()
      }
    },
  },
}
</script>
